export default __webpack_public_path__ + "static/media/event-disabled.4f110227.svg";